import React, { useMemo } from "react";

import { FireDepartmentPickerOmnisearch } from "../FireDepartmentPicker";
import { SupplementalAgencySection } from "../LocalAgencies/SupplementalAgencySection";

interface SupplementalFireDepartmentSectionProps {
  disabled?: boolean;
  readOnly?: boolean;
  facilityState?: string | null;
  existingAgencies?: Array<any> | null;
  primaryFireDepartmentId?: string | null;
  facilityLatitude?: number | null;
  facilityLongitude?: number | null;
}

export const SupplementalFireDepartmentSection: React.FC<
  SupplementalFireDepartmentSectionProps
> = ({
  disabled = false,
  readOnly = false,
  facilityState,
  existingAgencies,
  primaryFireDepartmentId,
  facilityLatitude,
  facilityLongitude,
}) => {
  const defaultSearch = useMemo(() => {
    if (facilityState) {
      return `state:${facilityState}`;
    }
    return "";
  }, [facilityState]);

  // Create a wrapper component that provides facility-specific search filtering
  const StateFilteredFireDepartmentPicker = (props: any) => (
    <FireDepartmentPickerOmnisearch
      {...props}
      defaultSearch={defaultSearch}
      resultFilter={(fireDepartment) => fireDepartment.id !== primaryFireDepartmentId}
      facilityLatitude={facilityLatitude}
      facilityLongitude={facilityLongitude}
    />
  );

  return (
    <SupplementalAgencySection
      disabled={disabled}
      readOnly={readOnly}
      fieldName="supplementalFireDepartmentIds"
      agencyKey="fireDepartment"
      existingAgencies={existingAgencies}
      addButtonText="ADDITIONAL FD"
      helperText="Secondary: this agency will not be included in your report in the portal, but will receive a copy of your Tier II report."
      pickerDescription="If you need to report to multiple FDs, choose from the list of FDs in your state above. If an FD does not have a latitude/longitude on file or if it has a P.O. Box, it will appear at the top of this list without a distance."
      PickerComponent={StateFilteredFireDepartmentPicker}
      facilityLatitude={facilityLatitude}
      facilityLongitude={facilityLongitude}
    />
  );
};
